import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateSmtpSettingsRequest,
  UpdateField,
  FetchSmtpSettingsRequest,
} from './smtp-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getSmtpSettingsState } from './smtp-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-smtp-settings',
  templateUrl: './smtp-settings.component.html',
  styleUrls: ['./smtp-settings.component.css'],
})
export class SmtpSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getSmtpSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchSmtpSettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SMTP_HOST: 'required',
      SMTP_PORT: 'required',
      SMTP_PASSWORD: 'required',
      SMTP_USERNAME: 'required',
      SMTP_FROM_EMAIL: 'required',
      SMTP_REQUIRES_AUTH: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SMTP_HOST: 'SMTP host',
      SMTP_PORT: 'SMTP port',
      SMTP_USERNAME: 'SMTP username',
      SMTP_PASSWORD: 'SMTP password',
      SMTP_FROM_EMAIL: 'SMTP from email',
      SMTP_REQUIRES_AUTH: 'SMTP requires auth',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const { SMTP_PORT, ...payload } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateSmtpSettingsRequest({
          SMTP_PORT: parseFloat(SMTP_PORT),
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
